/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LTI1p1ProviderDataParser = /* #__PURE__ */ parsers.object([
    ['tenantId', codecString, 'tenant_id'],
    ['label', /* #__PURE__ */ codecOptional(codecString)],
    [
        'lms',
        /* #__PURE__ */ parsers.exactly('Canvas', 'Blackboard', 'Sakai', 'Thought Industries', 'Open edX', 'Moodle', 'BrightSpace', 'Populi'),
    ],
    ['ltiVersion', /* #__PURE__ */ parsers.exactly('lti1.1'), 'lti_version'],
]);
export class LTI1p1ProviderData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTI1p1ProviderDataParser.decode(input).map(res => new LTI1p1ProviderData(res));
    }
    static unsafeDecode(input) {
        return LTI1p1ProviderData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTI1p1ProviderDataParser.encode(data);
    }
    static schema() {
        return LTI1p1ProviderDataParser.schema();
    }
}
